import { ActionReducer } from '@ngrx/store';
import { RootState } from './root-state';
import { RootActions } from './root.actions';

export function clearStateMetaReducer(reducer: ActionReducer<RootState>): ActionReducer<RootState> {
  return function (state, action) {
    if (action.type === RootActions.clearState.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}
